const InventoryServiceFactory = ({ HTTPInventory }) => {
    return {
        getInventory: (farmId) => {
            return HTTPInventory.get(`farm/${farmId}/dashboard/inventory`).then((res) => res.data);
        },
    };
};
export default InventoryServiceFactory;
//# sourceMappingURL=inventory.api.js.map